/* eslint-disable camelcase */
import get from 'lodash.get';

const TrackMapper = {

  mapSpotifyTracksToTracksTable(tracks) {
    return tracks.map(track => ({
      track_id: track.id,
      uri: track.uri,
      track: get(track, 'name', null),
      artist: get(track, 'artists', []).map(artist => artist.name).join(', '),
      album: get(track, 'album.name', null),
      duration: get(track, 'duration_ms', null),
      thumbnail: get(get(track, 'album.images', []).slice().pop(), 'url', null),
      preview_url: get(track, 'preview_url', null),
    }));
  },

};

export default TrackMapper;
